import type React from 'react';
import TopHeader from '@/components/TopHeader/TopHeader';
import { Toaster } from '@alchemer/ui/components/sonner';
import { useFlag } from '@alchemer/unleash';
import { FEATURE_FLAGS } from '@/config/features';

interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout = ({ children }: AppLayoutProps) => {
  const isUnifiedIntegrationEnabled = useFlag(FEATURE_FLAGS.UNIFIED_INTEGRATION);

  return (
    <div>
      <header className="sticky top-0 z-9">
        <TopHeader />
      </header>
      <main className="bg-chalkboard-50 overflow-y-auto">{children}</main>
      {!isUnifiedIntegrationEnabled && <Toaster position="bottom-center" />}
    </div>
  );
};
